module.exports = __webpack_public_path__ + "static/media/can-mother-be-wrong.fbd66376.jpg";